import { useState, useEffect } from "react";

/**
 * Detect if an element is visible
 * @param ref use useRef() to pass the element ref. The ref must not be conditionally displayed
 * @param triggerOnce true if you want to detect once
 * @see https://codesandbox.io/s/y7kr0vll4v
 */
export default function useOnScreen({ ref, rootMargin = "0px", triggerOnce }) {
	const [isIntersecting, setIntersecting] = useState(false);
	let cachedRef, observer;

	useEffect(() => {
		if ("IntersectionObserver" in window && ref.current) {
			cachedRef = ref.current;
			observer = new IntersectionObserver(
				([entry]) => {
					setIntersecting(entry.isIntersecting);

					if (entry.isIntersecting && triggerOnce) {
						observer.unobserve(ref.current);
					}
				},
				{
					rootMargin,
				}
			);
			observer.observe(cachedRef);
		}
		return () => {
			if (observer) {
				observer.unobserve(cachedRef);
			}
		};
	}, [ref.current]);

	return isIntersecting;
}
